import { render, staticRenderFns } from "./FeedQueueModal.vue?vue&type=template&id=c1542f3e&"
import script from "./FeedQueueModal.vue?vue&type=script&lang=js&"
export * from "./FeedQueueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports